import { render } from "./DefTextarea.vue?vue&type=template&id=f8ad67d6&scoped=true"
import script from "./DefTextarea.vue?vue&type=script&lang=js"
export * from "./DefTextarea.vue?vue&type=script&lang=js"

import "./DefTextarea.vue?vue&type=style&index=0&id=f8ad67d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ad67d6"]])

export default __exports__